<template>
    <div>
    <v-sheet color="blue-darken-4" elevation="10" max-width="600" rounded="lg" width="100%"
        class="pa-4 text-center mx-auto">
     <center><v-img src="@/assets/mindef1.jpg" alt="Imagen" class="img" max-height="110" width= 340 style="border-radius: 15px; box-shadow: 0px 0px 10px rgba(0,0,0,5);"></v-img></center>
       <br>
       <h2 class="text-h5 mb-1" style="font-family: 'Raleway', sans-serif; font-size: 24px; color: white; text-decoration:line-throungh;">
        DIRECCIÓN GENERAL DE LOGÍSTICA<br>
        UNIDAD DE MATERIAL BÉLICO
        </h2>
      </v-sheet>
    </div>
          </template>
          <script>
          </script>
    